import {Fab, Tooltip, Zoom} from '@material-ui/core';
import {withStyles, makeStyles} from '@material-ui/core/styles';
import {KeyboardArrowUpRounded} from '@material-ui/icons';
import React, {useEffect, useState} from 'react';
import {animateScroll} from 'react-scroll/modules';

type ScrollToTopProps = {
  overrideStyles?: React.CSSProperties;
};

const CustomizedToolTip = withStyles(theme => ({
  tooltip: {
    borderRadius: '10px',
    backgroundColor: 'rgba(62,80,96, 0.92)',
  },
}))(Tooltip);

const useStyles = makeStyles(theme => ({
  returnToTopIcon: {
    position: 'fixed',
    bottom: '65px',
    right: '1rem',
    width: '40px',
    height: '40px',
    transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '& .MuiSvgIcon-root': {
      width: '2rem',
      height: '2rem',
    },
    [theme.breakpoints.down('md')]: {
      width: '56px',
      height: '56px',
      bottom: '120px',
    },
  },
}));

const ScrollToTop = (props: ScrollToTopProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const classes = useStyles();
  const handleReturnToTopButtonVisibility = () => {
    window.scrollY > 50 ? setIsVisible(true) : setIsVisible(false);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleReturnToTopButtonVisibility);
    return () => window.removeEventListener('scroll', handleReturnToTopButtonVisibility);
  }, []);

  return (
    <Zoom
      in={isVisible}
      timeout={{enter: 400, exit: 400}}
      style={{transitionDelay: `${isVisible ? '100ms' : '200ms'}`}}
      mountOnEnter
      unmountOnExit
    >
      <CustomizedToolTip title="Scroll to top" placement="top" TransitionComponent={Zoom}>
        <Fab
          id="scroll-to-top"
          color="primary"
          onClick={async () => {
            animateScroll.scrollToTop({
              duration: 500,
              delay: 10,
              smooth: 'true',
              offset: 0,
            });
          }}
          className={classes.returnToTopIcon}
          style={props.overrideStyles}
        >
          <KeyboardArrowUpRounded />
        </Fab>
      </CustomizedToolTip>
    </Zoom>
  );
};

export default ScrollToTop;
